import React from 'react';
import Form from '../../../CommonComponents/Form';
import { Input } from '../../../CommonComponents/OPL/Input/Input';
import { InputNumberMask } from '../../../CommonComponents/OPL/Input/InputNumberMask';
import withForm from './withForm';

// InvestmentType is required and should be defaulted to 0: Personal
const baseAccount = { InvestmentType: 0 };

const RealEstateAssetForm = ({ account, onUpdate, isEditable }) => (
  <Form>
    <Form.Control>
      <InputNumberMask
        label="Market Value"
        leftIcon="fa fa-dollar-sign"
        allowNegative={false}
        disabled={!isEditable}
        value={account.MarketValue}
        onChange={({ target: { value } }) => onUpdate({ ...baseAccount, MarketValue: value })}
      />
    </Form.Control>
    <Form.Control>
      <Input
        label="Property Name"
        disabled={!isEditable}
        value={account.Name}
        onChange={({ target: { value } }) => onUpdate({ ...baseAccount, Name: value })}
      />
    </Form.Control>
  </Form>
);

export default withForm(RealEstateAssetForm);
